import DoAPICall from './DoAPICall'
//Get Menus
	export async function getWebPaymentMenus(client_id){
		const apiPayload = {
			httpMethod:'get',
			uri:'app/services?client_id='+client_id,
			payLoad:{},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}
	export async function getWebPaymentSubMenus(parent_id){
		const apiPayload = {
			httpMethod:'get',
			uri:'app/services/submenus?parent_id='+parent_id,
			payLoad:{},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}
//Get a customer from client
	export async function getCustomer(params){
		const apiPayload = {
			httpMethod:'get',
			uri:'app/customers?client_id='+params.client_id+'&customerAccount='
						+params.customerAccount+'&menu_id='+params.menu_id+'&paymentAmount='+params.paymentAmount,
			payLoad:{},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}
//Get MoMO Mno
	export async function getPaymentsProvidersOfClient(client_id){
		const apiPayload = {
			httpMethod:'get',
			uri:'app/paymentsprovidersofclient?client_id='+client_id,
			payLoad:{},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}
//Create Payment
	export async function makeMoMoPayment(payment){
		const apiPayload = {
			httpMethod:'post',
			uri:'app/paymentsviamomo',
			payLoad:{
					mobileNumber:payment.mobileNumber.replace(/\s/g, ""),
					walletNumber:payment.walletNumber.replace(/\s/g, ""),	
					customerAccount:payment.customerAccount,
					paymentAmount:payment.paymentAmount,
					reference:payment.reference,
					client_id:payment.client_id,
					wallet_id:payment.wallet_id,
					menu_id:payment.showSubMenu?payment.subMenu_id:payment.menu_id
				},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}

	export async function makeCardPayment(payment){
		const apiPayload = {
			httpMethod:'post',
			uri:'app/paymentsviacard',
			payLoad:{
					menu_id:payment.showSubMenu?payment.subMenu_id:payment.menu_id,
					customerAccount:payment.customerAccount,
					paymentAmount:payment.paymentAmount,
					reference:payment.reference,			
					client_id:payment.client_id,
					wallet_id:payment.wallet_id
				},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}

//Get status of submitted payment
	export async function getPaymentStatus(session_id){
		const apiPayload = {
			httpMethod:'get',
			uri:'app/payments/'+session_id,
			payLoad:{},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}

	export async function getCardPaymentStatus(transactionId){
		const apiPayload = {
			httpMethod:'get',
			uri:'app/cardpayments?id='+transactionId,
			payLoad:{},
			requestOptions:{}
		}
		return await DoAPICall(apiPayload)
	}